module.exports = __webpack_public_path__ + "img/gm.a87a814b.svg";